module.exports = __webpack_public_path__ + "media/src/images/partners/jgu-32d170faaa7ba55b5bd4c4abf6e9c69e.jpg";